"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ApiService_1 = require("../server/ApiService");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../gen-src/Localize");
var Notification_1 = require("../utils/Notification");
var TelemetryService_1 = require("../utils/TelemetryService");
var ShareButton = /** @class */ (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton(props) {
        var _this = _super.call(this, props) || this;
        // Public - only for testing purpose
        _this.handleClick = function () {
            _this.setState({ showSpinner: true });
            var onShareSuccess = function (result) {
                _this.setState({ showSpinner: false });
                // Only recording successful share events
                TelemetryService_1.TelemetryService.Instance.log(TelemetryService_1.ShareDialogUserActionOptions.ShareContent);
                Notification_1.Notification.Instance.showInfo(Localize_1.Messages.shareNotification({ CONTENT_NAME: _this.props.contentName }));
                if (result !== null && result !== undefined) {
                    _this.props.onSuccessHandler(result.successfulRecipients);
                }
            };
            var onShareFailure = function () {
                _this.setState({ showSpinner: false });
                Notification_1.Notification.Instance.showError(Localize_1.Messages.shareFailedNotification({ CONTENT_NAME: _this.props.contentName }));
            };
            if (_this.props.userIds.length === 0) {
                // When there is no recipient, show error toast and don't call the API
                Notification_1.Notification.Instance.showError(Localize_1.Messages.peoplePickerEmptyNotification());
            }
            else if (!_this.props.isAllUsersValid) {
                // When at least one recipient is invalid, show error toast and don't call the API
                Notification_1.Notification.Instance.showError(Localize_1.Messages.invalidEntryNotification());
            }
            else if (_this.props.onClickHandler) {
                // When custom click handler is provided, do NOT call the API
                _this.props.onClickHandler(_this.props.userIds, _this.props.message).then(onShareSuccess, onShareFailure);
            }
            else {
                // When all recipients are valid, call the API
                ApiService_1.ApiService.share(parseInt(_this.props.contentId, 10), _this.props.contentType, _this.props.userIds, _this.props.url, _this.props.message, _this.props.shouldShareThumbnail, _this.props.origin, _this.props.embed).then(onShareSuccess, onShareFailure);
            }
        };
        _this.state = { showSpinner: false };
        return _this;
    }
    ShareButton.prototype.render = function () {
        return (React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, children: Localize_1.Messages.share(), onClick: this.handleClick, testId: ShareButton.BUTTON_ID, showSpinner: this.state.showSpinner }));
    };
    ShareButton.BUTTON_ID = 'share-button';
    return ShareButton;
}(React.PureComponent));
exports.ShareButton = ShareButton;
//# sourceMappingURL=ShareButton.js.map